// Ordinals MUST match the backend enum com.mvs.backend.cn.enums.CommissionModelStatus
// (@Enumerated(ORDINAL)): ACTIVE, SCENARIO, ARCHIVED. There is no DRAFT on the backend.
export enum CommissionModelStatusEnum {
    ACTIVE,
    SCENARIO,
    ARCHIVED,
}
